import { FC } from 'react'
import { App, selectPage } from '../app/root'
import { useAppSelector } from '../hooks/useRTK'
import { useSetPage } from '../hooks'
import Error from './Error'
import JoinCollaboration from './JoinCollaboration'
import ConnectToContinue from './ConnectToContinue'
import ShareEmail from './ShareEmail'
import GrantingDocAccess from './GrantingDocAccess'
import ConnectToDrive from './ConnectToDrive'
import Pickers from './Pickers'
import InitialLoadingScreen from './InitialLoadingScreen'
import MicrosoftFileViewer from './MicrosoftFileViewer'
import MobileClientUpgradeScreen from './MobileClientUpgradeScreen'

type PageProps = {
  app: App
}

const Pages: FC<PageProps> = ({ app }) => {
  const page = useAppSelector(selectPage)

  useSetPage(app)
  // add new pages here and in the type in `root.ts` file
  switch (page) {
    case 'home':
      return <Pickers app={app} />
    case 'mobileClientUpgrade':
      return <MobileClientUpgradeScreen />
    case 'error':
      return <Error />
    case 'joinCollaboration':
      return <JoinCollaboration />
    case 'disconnected':
      return <ConnectToContinue />
    case 'shareEmail':
      return <ShareEmail />
    case 'grantingDocAccess':
      return <GrantingDocAccess />
    case 'connectToDrive':
      return <ConnectToDrive />
    case 'initialLoading':
      return <InitialLoadingScreen />
    case 'microsoftFileView':
      return <MicrosoftFileViewer collab={false} />
    case 'microsoftFileViewCollab':
      return <MicrosoftFileViewer collab />
    default:
      return <Error />
  }
}

export default Pages
